import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export function CollectionCard({ item, index, onSelect }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.55, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`collection-card-${item.id}`}
      className="group relative"
    >
      <div className="relative overflow-hidden rounded-2xl aspect-[4/5] bg-warmstone">
        <img
          src={item.img}
          alt={item.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <button
          data-testid={`collection-select-${item.id}`}
          onClick={() => onSelect(item)}
          className="absolute bottom-4 left-1/2 -translate-x-1/2 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400 rounded-full bg-alabaster text-ink text-xs font-medium px-5 py-2.5 inline-flex items-center gap-1.5 shadow-lg"
        >
          Select for Booking <ArrowUpRight size={13} />
        </button>
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl text-ink leading-snug">{item.name}</h3>
          <p className="mt-1 text-xs text-stone-500">{item.note}</p>
        </div>
        <span className="shrink-0 rounded-full bg-gold/10 border border-gold/20 px-3 py-1 text-[9px] font-mono uppercase tracking-[0.14em] text-gold-dark/80">
          {item.metal}
        </span>
      </div>
    </motion.article>
  );
}
